import React, { useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { AdminTableComponent } from './components/AdminTableComponent/AdminTableComponent';
import { UsersTableComponent } from './components/UsersTableComponent/UsersTableComponent';

export const Users = () => {
  const [alignment, setAlignment] = useState('Enabled');
  const [activatedAdminList, setActivatedAdminList] = useState(true);
  
  const handleChangeAlignment = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
    setAlignment(newAlignment);
  };
  
  return (
    <div>
      <div className="header">
        Here you can see a list of administrators who have access to Hajem admin panel and list of users who registered at application
      </div>
      <ToggleButtonGroup
        color="primary"
        key={alignment}
        value={alignment}
        defaultValue={'Enabled'}
        defaultChecked={true}
        exclusive
        onChange={handleChangeAlignment}
        aria-label="Platform"
        className="mt-5"
      >
        <ToggleButton onClick={() => setActivatedAdminList(true)} value="Enabled">Admin list</ToggleButton>
        <ToggleButton onClick={() => setActivatedAdminList(false)} value="Disabled">Users list</ToggleButton>
      </ToggleButtonGroup>
      {activatedAdminList ? <AdminTableComponent /> : <UsersTableComponent />}
    </div>
  );
}